import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const BooksIcon = props => {
  return <FontAwesomeIcon icon={['fas', 'books']} />;
};

export default BooksIcon;
